import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  theme = "light",
  ...props
}) => {
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-plum group-[.toaster]:border-plum/10 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-plum-light",
          actionButton:
            "group-[.toast]:bg-coral group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-plum/10 group-[.toast]:text-plum-light",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
